import TextFieldArea from 'components/TextFieldArea';
import { func, number, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import ControlSteps from '../../components/ControlSteps';
import DoneItemsList from '../../components/DoneItemsList';

const View2 = ({ viewIndex }, { fm, fmString, formValues, onChange }) => {
  const name =
    viewIndex === 2
      ? 'currentStatus'
      : viewIndex === 3
        ? 'clearlyWorseStatus'
        : viewIndex === 4
          ? 'nearFutureTarget'
          : viewIndex === 5
            ? 'betterStatus'
            : viewIndex === 6
              ? 'clearlyBetterStatus'
              : '';

  const getValue = () => path(['rehab5', name], formValues) || '';

  const onChangeText = event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };

  const controlStepsData = {
    currentStatus: viewIndex > 2 ? path(['rehab5', 'currentStatus'], formValues) : null,
    clearlyWorseStatus: viewIndex > 3 ? path(['rehab5', 'clearlyWorseStatus'], formValues) : null,
    nearFutureTarget: viewIndex > 4 ? path(['rehab5', 'nearFutureTarget'], formValues) : null,
    betterStatus: viewIndex > 5 ? path(['rehab5', 'betterStatus'], formValues) : null,
    clearlyBetterStatus: viewIndex > 6 ? path(['rehab5', 'clearlyBetterStatus'], formValues) : null,
  };

  const doneItems = [
    { locale: 'onlineRehabilitation.rehab5.cognitiveProblemsGiven', canUpdate: false },
    ...(viewIndex > 6 ? [{ locale: 'onlineRehabilitation.rehab5.cognitiveProblemsGoals', canUpdate: false }] : []),
  ];

  const sessionFinished = !!path(['rehab5', 'finished'], formValues);
  return (
    <ContentColumns
      firstColumn={
        <div>
          <h2>{fm('onlineRehabilitation.rehab5.2.header')}</h2>
          <br />
          {viewIndex === 2 && (
            <div>
              <div>{fm('onlineRehabilitation.rehab5.2.firstText')}</div>
              <br />
            </div>
          )}
          {viewIndex < 7 && (
            <div>
              <h3>{fm(`onlineRehabilitation.rehab5.${viewIndex}.subtitle`)}</h3>
              <div>{fm(`onlineRehabilitation.rehab5.${viewIndex}.text`)}</div>
              <br />
              <TextFieldArea
                editing
                input={{ name, onChange: onChangeText, value: getValue() }}
                hintLocale={`onlineRehabilitation.rehab5.${viewIndex}.inputPlaceholder`}
                localeMessage={fmString}
                rows={4}
                viewStyle={{ width: '100%' }}
                disabled={sessionFinished}
              />
              <br />
              <br />
            </div>
          )}
          <ControlSteps steps={controlStepsData} cognition fm={fm} />
        </div>
      }
      secondColumn={
        <div>
          <DoneItemsList itemList={doneItems} />
        </div>
      }
    />
  );
};

View2.contextTypes = {
  fm: func,
  fmString: func,
  formValues: object,
  onChange: func,
};
View2.propTypes = {
  viewIndex: number,
};

export default View2;
